module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Senior-06Merit_Prize_S05.af965076.png";